'use strict';

import * as Props from '../Props';

const angular = require('angular');

const TimepickerProperties = {
    Basic: {
        'ControlType': 'Timepicker',
        'Label': {
            name: 'label',
            selectedValue: 'Timepicker',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Timepicker'),
        'Data Field Name': Props.getDataFieldName('Timepicker'),
        'Time Format' : {
            name: 'hour_12_format',
            type: 'dd',
            options: [
                {
                    value: true,
                    key: '12Hrs'
                }, {
                    value: false,
                    key: '24Hrs'
                }],
            selectedValue: 'false',
            onChangeFunction: 'updateDefaultTime'
        },
        'Default': {
            name: 'default.time',
            selectedValue: '',
            type: 'timepicker',
            dateObj: '',
            timeType: '1',
            onChangeFunction: 'checkValidInput'
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox',
            disable: false
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    }
};

export default TimepickerProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Timepicker.ts